import {Component, ElementRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {IAddress} from '../../../shared/interfaces/IAddress';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-postal-code-selector-dialog',
  templateUrl: './postal-code-selector-dialog.component.html',
  styleUrls: ['./postal-code-selector-dialog.component.scss']
})
export class PostalCodeSelectorDialogComponent implements OnInit {

  @ViewChild('map', {static: false}) mapElement: ElementRef;
  map: google.maps.Map;
  center = new google.maps.LatLng(-34.6034707, -58.4563128);
  mapOptions: google.maps.MapOptions = {
    center: this.center,
    maxZoom: 20,
    minZoom: 18,
    zoom: 10,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    streetViewControl: false,
    mapTypeControl: false
  };
  myControl = new FormControl();
  latitude: number;
  longitude: number;
  zipCode: number;
  autocompleteService: any;
  placesService: any;
  query = '';
  places: any = [];
  searchDisabled: boolean;
  saveDisabled: boolean;
  location: IAddress;
  infoWindow: google.maps.InfoWindow;
  marker: google.maps.Marker;
  markerCluster: any;


  constructor(public zone: NgZone) { }

  ngOnInit(): void {
    if (this.location) {
      this.marker = new google.maps.Marker({
        position: {lat: this.location.lat, lng: this.location.lon},
        map: this.map,
        draggable: true
      });
      this.query = this.location.nomenclature;
      this.center = new google.maps.LatLng(this.location.lat, this.location.lon);
      this.mapOptions = {
        center: this.center,
        maxZoom: 20,
        minZoom: 18,
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControl: false
      };
    }
  }

  ngAfterViewInit(): void {
    this.loadMap();
  }
  loadMap(): void {

    this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapOptions);
// this.marker = new google.maps.Marker({position: this.center, map:this.map})
    this.infoWindow = new google.maps.InfoWindow();
    this.marker = new google.maps.Marker({
      position: this.center,
      map: this.map,
      draggable: true
    });
    this.marker.addListener('dragend', () => {
      this.getCityByCoords(this.marker.getPosition().lat(), this.marker.getPosition().lng()).then((x) => {
        if (x[1] && x[1].formatted_address) {
          this.query = x[1].formatted_address;
          const address = x[0].address_components;
          const zipcode = address[address.length - 1].long_name;
          if (zipcode) {
            this.zipCode = parseInt(zipcode.replace(/\D/g, ''), null);
          }
          console.log(zipcode);
          const location = {
            lat: this.marker.getPosition().lat(),
            lon: this.marker.getPosition().lng(),
            nomenclature: x[1].formatted_address
          };
          this.query = location.nomenclature;
          this.map.setCenter({lat: this.marker.getPosition().lat(), lng: this.marker.getPosition().lng()});

          this.location = location;
        } else {
          console.log(this.marker.getPosition().lat() + ', ' + this.marker.getPosition().lng());
        }
      });
    });

    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(this.map);
    this.searchDisabled = false;
  }
  getCityByCoords(lat, lng): Promise<any> {
    return new Promise( (onResolve, onReject) => {
      new google.maps.Geocoder().geocode({ location: new google.maps.LatLng(lat, lng) },  (onResults, onStatus) => {

        if (onStatus === google.maps.GeocoderStatus.OK) {
          onResolve(onResults);
        } else {
          onReject(onStatus);
        }
      });
    });
  }
  selectPlace(place){

    this.places = [];

    const location = {
      lat: null,
      lon: null,
      nomenclature: place.name
    };
    this.query = place.name;

    this.placesService.getDetails({placeId: place.place_id}, (details) => {

      this.zone.run(() => {
        console.log(details);
        location.nomenclature = details.name;
        location.lat = details.geometry.location.lat();
        location.lon = details.geometry.location.lng();
        this.saveDisabled = false;

        this.map.setCenter({lat: location.lat, lng: location.lon});

        this.location = location;
        this.marker = new google.maps.Marker({
          position: {lat: location.lat, lng: location.lon},
          map: this.map,
          draggable: true
        });

      });

    });

  }

  searchPlace(){

    this.saveDisabled = true;

    if (this.query.length > 0 && !this.searchDisabled) {

      const config = {
        types: ['geocode'],
        input: this.query
      };

      this.autocompleteService.getPlacePredictions(config, (predictions, status) => {

        if (status === google.maps.places.PlacesServiceStatus.OK && predictions){

          this.places = [];

          predictions.forEach((prediction) => {
            this.places.push(prediction);
          });
        }

      });

    } else {
      this.places = [];
    }

  }
}
